export const ENVIO_GRATIS_MINIMO = 2500;
export const ZONA_ENVIO_GRATIS = `Envío gratis a partir de $${ENVIO_GRATIS_MINIMO} en compra`;
